import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    lowerCaseLng: true,
    supportedLngs: ['en'],
    interpolation: {
      escapeValue: false,
    },
    ns: [
      'common',
      'Modal',
      'SystemMessages',
      'LoginPage',
      'OverallFunctionality',
      'User',
      'ClientSetup',
      'AccountSetup',
      'FileMappingSetup',
      'UserRoles',
      'BankSetup',
      'AddNewIssuedCheck',
      'SubmitIssuedCheck',
      'FileMappingSetup',
      'ClientUserSetup',
      'HelpPage',
      'IssuedCheckProcessingLog',
      'PayeeMatchParameters',
      'AllTransactions',
      'ACHExceptionRule',
      'BusinessAdminLogs',
      'TransactionResult',
      'QuickExceptionProcessing',
      'SentEmailLog',
      'AuditTrailLog',
      'BroadcastEmail',
      'ExceptionItem',
      'PurgeTransactions',
      'CheckVerification',
      'QuickExceptionSetup',
      'VoidChecks',
      'SystemWideRules',
    ],
    // defaultNS: 'common',
    react: {
      useSuspense: true,
    },
    lng: localStorage.getItem('lng') || 'en',
    backend: {
      loadPath: '/locales/v2/{{lng}}/{{ns}}.json',
    },
  })

export default i18n
